import {
  NeedItem,
  NeedStatus,
  NeedType,
} from "pages/dashboard/home/dashboardService";

export const WIRE_FRAUD_TASK_TITLE = "Protect yourself from wire fraud";
export const WIRE_FRAUD_TASK_DESCRIPTION =
  "Review important information about how to recognize and avoid wire fraud.";
export const WIRE_FRAUD_DETAIL_DESCRIPTION =
  "Please read this document carefully. Wire fraud is a growing risk during real estate closings.";
export const WIRE_FRAUD_DOCUMENT_TITLE = "Protecting Against Wire Fraud";
export const WIRE_FRAUD_DOCUMENT_LOAD_ERROR =
  "We are having issues loading your documents. Try again later.";
export const WIRE_FRAUD_ACKNOWLEDGED_MESSAGE = "Successfully Acknowledged!";
export const WIRE_FRAUD_COMPLETED_DESCRIPTION = "You have reviewed this document.";
const MY_TASKS_PREVIEW_LIMIT = 3;

export const isWireFraudTask = (task: NeedItem): boolean =>
  task.needType === NeedType.WireFraud;

export const filterWireFraudDisplayTasks = (
  tasks: NeedItem[],
  wireFraudDocumentEnabled?: boolean,
): NeedItem[] =>
  tasks.filter((task) => {
    if (!isWireFraudTask(task)) {
      return true;
    }

    if (wireFraudDocumentEnabled !== true) {
      return false;
    }

    const status = task.needStatus?.toLowerCase();
    return status !== NeedStatus.ReviewNeeded.toLowerCase()
      && status !== NeedStatus.Satisfied.toLowerCase();
  });

export const selectMyTasksPreview = (tasks: NeedItem[]): NeedItem[] => {
  const incompleteTasks = tasks.filter(
    (task) => task.needStatus?.toLowerCase() !== NeedStatus.Completed.toLowerCase(),
  );
  const wireFraudTask = incompleteTasks.find(isWireFraudTask);
  if (!wireFraudTask) {
    return incompleteTasks.slice(0, MY_TASKS_PREVIEW_LIMIT);
  }

  const otherTasks = incompleteTasks.filter((task) => task !== wireFraudTask);
  return [wireFraudTask, ...otherTasks].slice(0, MY_TASKS_PREVIEW_LIMIT);
};

export const getTaskDisplayTitle = (task: NeedItem): string =>
  isWireFraudTask(task) ? WIRE_FRAUD_TASK_TITLE : task.title;
